import { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

function useResizeContainer(outerContainerRef, autoSizeHeight, debounceTime = 500) {
  const [containerHeight, setContainerHeight] = useState('100%');

  const resizeContainer = useCallback(() => {
    if (outerContainerRef.current) {
      const { top } = outerContainerRef.current.getBoundingClientRect();
      setContainerHeight(window.innerHeight - top);
    }
  }, [outerContainerRef]);

  const debouncedResizeContainer = useCallback(debounce(resizeContainer, debounceTime), [resizeContainer, debounceTime]);

  useEffect(() => {
    if (!autoSizeHeight) return;

    window.addEventListener('resize', debouncedResizeContainer);
    debouncedResizeContainer();

    return () => {
      if (!autoSizeHeight) return;
      window.removeEventListener('resize', debouncedResizeContainer);
    };
  }, [autoSizeHeight, debouncedResizeContainer]);

  return containerHeight;
}

export default useResizeContainer;
